import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link, NavLink } from 'react-router-dom';
import './history.css';
import Typography from '@material-ui/core/Typography';
import NoOrders from '@material-ui/icons/RemoveShoppingCart';
import firebase from 'firebase';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import ArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import MakeOrder from '@material-ui/icons/RestaurantMenu';
import moment from 'moment';
import strings from './components/language/language';
import { Grid } from '../node_modules/@material-ui/core';
import ErrorImage from './history-icons/error.svg';
import notReadyImage from './history-icons/bbqempty.svg';
import readyImage from './history-icons/bbqFILLED.svg';
import confirmedImage from './history-icons/checkk.svg';

const styles = (theme) => ({
  root: {
    textTransform: 'capitalize',
  },
  backButton: {
    bottom: 5,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#998d9059',
    },
  },
});

// class history extends Component {

// render () {
//   const { classes } = this.props;
// return(
//   <div>
//   <div id="checkout-header">
//   <NavLink to="/"><Icon id="back-icon">arrow_back_ios</Icon></NavLink>
// </div>

//     <div className="history-container">
//     <div><p className="history-page-title">Your Recent Orders</p></div>

//     <div className="hr-sect">27th November, 2018</div>
//     <List>

//           <ListItem className="history-list-item" key="{value}" role={undefined} dense >
//             <ListItemText primary={<Typography  style={{"fontSize":"15px"}} variant="title" gutterBottom>Chicken Pizzaya</Typography>}
//                           secondary={<Typography style={{"fontSize":"13px"}} variant="caption">2x Medium - 120 EGP</Typography>}
//             />

//             <ListItemSecondaryAction>
//               <Button className="add-cart-button"><Typography classes={{root:classes.root}} style={{"color":"white", "fontSize":"12px"}} variant="subheading">Add to cart</Typography></Button>
//             </ListItemSecondaryAction>
//           </ListItem>

//           <ListItem className="history-list-item" key="{value}" role={undefined} dense >
//             <ListItemText primary={<Typography  style={{"fontSize":"15px"}} variant="title" gutterBottom>Chicken Pizzaya</Typography>}
//                           secondary={<Typography style={{"fontSize":"13px"}} variant="caption">2x Medium - 120 EGP</Typography>}
//             />

//             <ListItemSecondaryAction>
//               <Button className="add-cart-button"><Typography classes={{root:classes.root}} style={{"color":"white", "fontSize":"12px"}} variant="subheading">Add to cart</Typography></Button>
//             </ListItemSecondaryAction>
//           </ListItem>

//     </List>

//     </div>
// </div>
//    )
// }
// }
// export default withStyles(styles)(history);

const _stringifyObj = (obj) => {
  var myobj = { ...obj };

  let addition_string = '';
  // myobj.forEach(cartitem=>{
  //     addition_string=addition_string+"x"+cartitem.count+" "+cartitem.size+cartitem.cartitem.name+" "
  // })
  for (var item in myobj) {
    let addition_string = '';
    myobj[item].data.cart.forEach((cartitem) => {
      addition_string =
        addition_string +
        'x' +
        cartitem.count +
        ' ' +
        cartitem.size +
        cartitem.name +
        ' ';
    });
    myobj[item].order_string = addition_string;
  }
  return myobj;
};
class history extends Component {
  state = {
    orders: [],
  };
  componentDidMount() {
    let temp = [];
    // console.log('restaurant name ', this.props.restaurant_name);
    // console.log('user id  ', this.props.messenger_user_id);
    firebase
      .database()
      .ref('/restaurants/0/' + this.props.restaurant_name + '/orders')
      .orderByChild('messenger_user_id')
      .equalTo(this.props.messenger_user_id)
      .on('value', (snapshot) => {
        // console.log('orders : ', snapshot.val());
        temp = [];
        snapshot.forEach((childSnapShot) => {
          temp.push({ key: childSnapShot.key, data: childSnapShot.val() });
          // console.log(childSnapShot.key);
        });

        let new_state = _stringifyObj(temp);

        let aux_array = [];
        for (var item in new_state) aux_array.push(new_state[item]);
        // console.log(new_state)
        // console.log(aux_array);
        aux_array.sort((a, b) => {
          if (moment(a.data.timestamp).isBefore(b.data.timestamp)) return 11;
          else return -11;
        });
        // console.log(aux_array);
        this.setState({ orders: aux_array });
      });
  }
  addItem = (cart) => {
    let aux_array = [];
    for (var item in cart) aux_array.push(cart[item]);

    this.props.add_items(null, null, null, null, aux_array);
  };

  stateToText(state, cancellReason) {
    switch (state) {
      case 1:
        return 'الطلب ينتظر الموافقة';
        break;
      case 5:
        return `تم الغاء الطلب ${cancellReason ? ': ' + cancellReason : ''}`;
        break;
      case 3:
        return `تم الغاء الطلب ${cancellReason ? ': ' + cancellReason : ''}`;
        break;
      case 2:
        return `تم قبول الطلب`;
        break;

      default:
        break;
    }
  }

  render() {
    const { classes } = this.props;
    console.log(this.state.orders);
    return (
      <div style={{ backgroundColor: '#f5f2f2' }}>
        <div
          id='edit-cart-header'
          style={{ backgroundColor: this.props.color }}
        >
          <NavLink to='/' style={{ textDecoration: 'none' }}>
            <Button className={classes.backButton}>
              <ArrowLeft /> {strings.back}
            </Button>
          </NavLink>
        </div>
        <div className='history-container'>
          <div style={{ marginBottom: 15 }}>
            <h1
              className='history-page-title'
              style={{ color: this.props.color }}
            >
              {strings.recent_orders}
            </h1>

            {this.state.orders ? (
              <React.Fragment>
                {this.state.orders.map((value, i) => {
                  return (
                    <div
                      className='list-container'
                      style={{ margin: 'auto', width: '50%', marginBottom: 50 }}
                    >
                      {/* <ListItem key={value} role={undefined} dense >
            <ListItemText primary={value.order_string} />
            <ListItemSecondaryAction>
              <NavLink to="/">
              <IconButton aria-label="Comments" onClick={()=>this.addItem({...value.data.cart})}>
                <AddIcon />
                <Typography>Reorder</Typography>
              </IconButton>
              </NavLink>
            </ListItemSecondaryAction>
          </ListItem> */}
                      {console.log(value.data.state)}
                      <List
                        style={{ margin: '0 10px' }}
                        className='order-container'
                      >
                        <div className='hr-sect'>
                          {moment(value.data.timestamp).format('LL')}
                        </div>
                        <ListItem
                          className='history-list-item'
                          key={value}
                          role={undefined}
                          dense
                        >
                          <Grid container>
                            <Grid container>
                              {/* <Grid item xs={8}> */}
                              <Grid
                                item
                                xs={12}
                                style={{
                                  textAlign:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'right'
                                      : 'left',
                                }}
                              >
                                <ListItemText
                                  primary={
                                    <Typography
                                      style={{ fontSize: '15px' }}
                                      variant='title'
                                      gutterBottom
                                    />
                                  }
                                  secondary={value.data.cart.map((item) => {
                                    return (
                                      <Typography
                                        style={{ fontSize: '14px' }}
                                        variant='caption'
                                      >
                                        {item.count}x {item.name} {}
                                      </Typography>
                                    );
                                  })}
                                />
                              </Grid>
                              {/* <Grid item xs={4} /> */}
                            </Grid>

                            <Grid container>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  textAlign:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 'right'
                                      : 'unset',
                                  paddingRight:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? 16
                                      : 'unset',
                                }}
                              >
                                <p
                                  className='history-total'
                                  style={{ color: this.props.color }}
                                >
                                  {value.data.total} {strings.currency}
                                </p>
                              </Grid>

                              <Grid
                                item
                                xs={6}
                                style={{
                                  order:
                                    (this.props.lang === 'ar') |
                                    (this.props.lang === 'qrAR')
                                      ? -1
                                      : 'unset',
                                }}
                              >
                                {/* <ListItemSecondaryAction> */}
                                {value.data.state !== 1 &&
                                  value.data.state !== 2 && (
                                    <NavLink
                                      to='/order'
                                      style={{ textDecoration: 'none' }}
                                    >
                                      <Button
                                        title={'Reorder' + i}
                                        onClick={() =>
                                          this.addItem({ ...value.data.cart })
                                        }
                                        className='add-cart-button'
                                        style={{
                                          backgroundColor: this.props.color
                                            ? this.props.color
                                            : '#70142b',
                                        }}
                                      >
                                        <Typography
                                          classes={{ root: classes.root }}
                                          style={{
                                            color: 'white',
                                            fontSize: '12px',
                                          }}
                                          variant='subheading'
                                        >
                                          {strings.add_to_basket}
                                        </Typography>
                                      </Button>
                                    </NavLink>
                                  )}

                                {/* </ListItemSecondaryAction> */}
                              </Grid>

                              <Typography
                                className='order'
                                variant='subheading'
                              >
                                {this.stateToText(
                                  value.data.state,
                                  value.data.cancel_reason
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-around',
                              width: '100%',
                              position: 'relative',
                            }}
                          >
                            {!(
                              value.data.state === 3 || value.data.state === 5
                            ) && (
                              <hr
                                style={{
                                  position: 'absolute',
                                  width: '50%',
                                  right: '20%',
                                  top: '30%',
                                  borderTop: '1px dashed grey',
                                }}
                              />
                            )}
                            {!(
                              value.data.state === 3 || value.data.state === 5
                            ) && (
                              <div style={{ zIndex: 2, width: '20%' }}>
                                <img width='100%' src={confirmedImage} />
                                <p style={{ textAlign: 'center', margin: 3 }}>
                                  اتبعت
                                </p>
                              </div>
                            )}
                            {value.data.state === 1 && (
                              <div style={{ zIndex: 2, width: '20%' }}>
                                <img width='100%' src={notReadyImage} />
                                <p style={{ textAlign: 'center', margin: 3 }}>
                                  ينتظر الموافقة
                                </p>
                              </div>
                            )}
                            {value.data.state === 2 && (
                              <div style={{ zIndex: 2, width: '20%' }}>
                                <img width='100%' src={readyImage} />
                                <p style={{ textAlign: 'center', margin: 3 }}>
                                  اتقبل
                                </p>
                              </div>
                            )}

                            {(value.data.state === 3 ||
                              value.data.state === 5) && (
                              <div style={{ zIndex: 2, width: '20%' }}>
                                <img width='100%' src={ErrorImage} />
                                <p style={{ textAlign: 'center', margin: 3 }}>
                                  اترفض
                                </p>
                              </div>
                            )}
                          </div>
                        </ListItem>
                      </List>
                    </div>
                  );
                })}
              </React.Fragment>
            ) : (
              <div>
                <div className='no-order-container'>
                  <NoOrders className='no-order-icon' />
                  <span className='no-order-message'>
                    You have no orders yet !
                  </span>
                </div>
                <Link to='/' style={{ textDecoration: 'none' }}>
                  <button className='make-order'>
                    <MakeOrder className='make-order-icon' />
                    <span className='make-order-text'>Make Order</span>
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(history);



// WEBPACK FOOTER //
// ./src/history.js